<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" @change="changeFilterFreeText" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    @change="changeFilter"
                    :format="dateFormat"
                  />
                </div>

                <div class="m-form-item-wrapper">
                  <label>User CC</label>
                  <a-select
                    placeholder="Select User CC!"
                    v-model="user_cc"
                    @change="changeFilter"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option v-for="item in userCCList" :key="item.tlc_user">
                      {{ item.tlc_user }} | {{ item.type_cc }} | {{ item.no_cc }} 
                    </a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper" v-if="activeTab=='list'">
                  <label>Transaction Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="changeFilter"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered"
                      >Delivered</a-select-option
                    >
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred"
                      >Transferred</a-select-option
                    >
                  </a-select>
                </div>

              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="loadings.tab"
      >
      <DataList
        title="Traveloka Claim List"
        createLink="travelokaklaimCreate"
        manifestLink="travelokaklaimManifest"
        editLink="travelokaklaimRevise"
        :tabbedTransactional="true"
        :dataList="transList"
        :draftList="draftList"
        draftEditLink="travelokaklaimDraft"
        :flagdisabledEdit="false"
        :draftDeleteLink="true"
        :allowcancel="false"
      />
      </a-spin>
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "ListPO",
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      loading: true,
      dateFormat: "DD-MM-YYYY",
      transList: [],
      draftList: [],
      basedList: [],
      userCCList: [],
      search: undefined,
      user_cc: undefined,
      tempList: "",
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      activeTab: "list",
      loadings: {
        tab: false,
        cancel: false,
      },
      timer_debounce: null
    };
  },
  created() {
    this.getComboUserCC();
    this.fetchData();
  },
  mounted() {
    Event.$on("emitDeleteLink", this.deleteDraft);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("emitDeleteLink", this.deleteDraft);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("callbackTab", this.clickTabed);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ])
  },
  methods: {
    moment,
    fetchData(jenis) {
      const list_ = (!jenis || jenis=='list' ? axios({
        method: "get",
        url: this.$serviceUrl + "klaim_tiket",
        params: {
          jenis: 'laporan',
          cari: (this.search ? this.search : null),
          start_date : (this.transactionDt[0] ? moment(this.transactionDt[0]).format(this.getStandartFormatDate) : null),
          end_date: (this.transactionDt[1] ? moment(this.transactionDt[1]).format(this.getStandartFormatDate) : null),
          director: (this.user_cc ? this.user_cc : null),
          status: (this.status ? this.status : null)
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }) : null)

      const draft_ = (!jenis || jenis=='draft' ? axios({
        method: "get",
        url: this.$serviceUrl + "klaim_tiket",
        params: {
          jenis: 'draft',
          cari: (this.search ? this.search : null),
          start_date : (this.transactionDt[0] ? moment(this.transactionDt[0]).format(this.getStandartFormatDate) : null),
          end_date: (this.transactionDt[1] ? moment(this.transactionDt[1]).format(this.getStandartFormatDate) : null),
          director: (this.user_cc ? this.user_cc : null),
          status: (this.status ? this.status : null)
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }) : null)

      this.loadings.tab = true
      axios.all([
        (list_ ? list_.catch((err) => {
          console.log(err);
          return null;
        }) : null),
        (draft_ ? draft_.catch((err) => {
          console.log(err);
          return null;
        }) : null),
      ]).then((response) => {
        //Transaction List
        if(list_){
            this.transList = [];
          _.forEach(response[0].data.data, (data) => {
            this.transList.push({
              title: data.no_transaksi,
              timeline: JSON.parse(data.status_app),
              unread: (data.unread && data.unread == "1") ? true : false,
              subdesc: [
                moment(data.report_date).format(this.getStandartFormatDate),
                data.cc_user,
                data.cc_type+" | "+data.cc_no,
                this.formatCurrency(data.currency, data.total),
              ],
              status: data.status,
              id: data.id_laporan,
              kode_project: data.kode_project,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : (data.cancel_sts == 2 ? "Unusual":null)
                : null,
              islistPPrevised: data.cancel_sts == 2 ? true:false,
              receiveStatus: data.delivered,
              supplier: data.supplier,
              tgl_buat: data.report_date,
              peruntukan: data.peruntukan,
              searchQ:
                data.no_transaksi +
                data.cc_type +
                data.total +
                data.currency +
                data.cc_user +
                data.cc_no,
            });
          });
        }
        
        //Draft
        if(draft_){
          this.draftList = [];
          _.forEach(response[1].data.data, (item) => {
            this.draftList.push({
              title: 'Draft',
              subdesc: [
                item.cc_no,
                item.cc_type,
                item.cc_user,
                this.formatCurrency(item.currency, item.grand_total),
              ],
              id: item.id_laporan,
              tgl_buat: moment(item.report_date).format(this.getStandartFormatDate),
              loading_delete: false,
              searchQ:
                item.cc_no +
                " " +
                item.cc_type +
                " " +
                item.cc_user +
                " " +
                this.formatCurrency(item.currency, item.grand_total)

            });
          });
        }

        this.loadings.tab = false;
      })
    },
    async getComboUserCC() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_tiket/combo",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.userCCList = response.data.kartu_kredit
      });
    },
    canceltrans(item) {
      this.loading.cancel = true;
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "po",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go()
          this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading.cancel = false;
            this.displayMessage("empty-db");
          }
        });
    },
    resetFilter() {
      this.search = null;
      this.user_cc = undefined;
      this.status = undefined;
      this.transactionDt = [];
    },
    clickTabed(val) {
      this.activeTab = val;
      this.loadings.tab = true;
      this.transList = [];
      this.resetFilter();
      this.fetchData();
    },
    deleteDraft(val) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let indx = _.findIndex(that.draftList, (e) => { return e.id == val.id })
          that.draftList[indx].loading_delete = true;
          that.asyncAxiosDelete(
            "po/draft",
            "application/json",
            that.getAuth,
            {
              id_po: val.id,
            }
          )
            .then(() => {
              that.draftList = _.filter(that.draftList, (e) => e.id != val.id)
              that.$router.go();
            })
            .catch((err) => {
              console.log(err)
              that.draftList[indx].loading_delete = false;
            });
        },
        onCancel() { },
      })
    },
    changeFilter(){
      this.fetchData(this.activeTab);
    },
    changeFilterFreeText(){
      clearTimeout(this.timer_debounce);
      this.timer_debounce = setTimeout(() => {
        this.fetchData(this.activeTab);
      }, 1000);
    }
  },
};
</script>